import Immutable from "immutable";
import { floatToMoney } from "lib/money";

import * as studentLinked from "lib/appserver/entityHeaders/studentLinked";

const MealHistoryItem = new Immutable.Record({
  date: undefined,
  selections: undefined,
  totalPrice: undefined,
  ...studentLinked.defaultProperties
}, "Meal History Item");

function buildMealHistoryItemFromAppserver(rawHistoryItem) {
  const rawMealHistoryItem = rawHistoryItem.payload;
  // TODO: fix this on the server end (hopefully?)
  rawHistoryItem.student_fk = rawMealHistoryItem.student_fk;
  return MealHistoryItem({
    date: rawMealHistoryItem.dinner_date,
    selections: buildSelectionsFromAppserver(rawMealHistoryItem),
    totalPrice: floatToMoney(rawMealHistoryItem.total_cost),
    ...studentLinked.appserverAdapter(rawHistoryItem)
  })
}

function buildSelectionsFromAppserver(rawMealHistoryItem) {
  return rawMealHistoryItem.meals_selected.map(selection => ({
    name: selection.name,
    price: floatToMoney(selection.price)
  }))
}

MealHistoryItem.fromAppserver = buildMealHistoryItemFromAppserver;
export default MealHistoryItem;



// WEBPACK FOOTER //
// ./src/state/school_money/entities/MealHistoryItem.js